import { MypageStateContext } from 'contexts/mypage_state_context';
import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';

const MypageInstrumentSharingRoute = () => {
  const mypageState = useContext(MypageStateContext);
  const location = useLocation();
  const isSharing = mypageState.currentUser.laboratory?.authority?.enableInstrumentSharing ?? false;

  return isSharing ? (
    <div>
      <Outlet />
    </div>
  ) : (
    <Navigate to={MypageRouteHelper.login()} state={{ from: location }} replace />
  );
};

export default MypageInstrumentSharingRoute;
